@if (blockUi) {
  <div class="loading-image-container">
    <div class="loading-image small"></div>
    <div class="loading-text">Loading ...</div>
  </div>
}

<mat-sidenav-container>
  <section class="container">
    <div class="header-wrapper">
      <div class="row">
        <div class="col-060">
          <h2>User Directory</h2>
        </div>
        <div class="col-040">
          <div class="col">
            <p class="margin-bottom-none">
              Restrict Tenant (<strong>{{ tenant.Value }}</strong>): <mat-slide-toggle [checked]="tenant.RestrictTenant" (change)="toggleTenantRestrict()"></mat-slide-toggle>
            </p>
          </div>
          <div class="col">
            <p class="margin-bottom-none col-100">
              <input type="text" class="search-box" [(ngModel)]="filterText" (ngModelChange)="filterUsers()" placeholder="Find Users" data-qa-id="permissions-input-search" />
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="content-wrapper">
      <table class="table-fancy" ng-show="users" data-qa-id="permissions-table-users">
        <tr class="">
          <th>Name</th>
          <th>Username</th>
          <th>Email</th>
          <th>ACT Access</th>
        </tr>
        @for (user of users; track user) {
          <tr>
            <td>
              {{ user.Name }}
            </td>
            <td>{{ user.Username }}</td>
            <td>{{ user.Email }}</td>
            <td style="text-align: center">
              <mat-slide-toggle [disabled]="user.Disabled" [checked]="user.Enable" (change)="enableAccess(user.UserId, user.Enable = !user.Enable)"></mat-slide-toggle>
            </td>
          </tr>
        }
      </table>
      <table class="table-fancy" ng-show="users">
        <tbody>
          <tr>
            <td class="aw-paging">
              <span class="tbl">
                <span class="tr">
                  <span class="td top count resultLabel">
                    <strong>Results:</strong>
                    {{ resultsCount }}
                  </span>
                </span>
              </span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </section>
</mat-sidenav-container>
